<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <CInput
            :label="labelName"
            :value.sync="fileConfigurationComponent.name"
            :horizontal="horizontal"
            :placeholder="placeholderName"
            :size="size"
        >
        </CInput>
        <CSelect
            :value.sync="fileConfigurationComponent.format"
            :options="[
                {
                    value: 'csv',
                    label: 'csv',
                },
            ]"
            :label="labelFormat"
            :horizontal="horizontal"
            :placeholder="placeholderFormat"
            :size="size"
        >
        </CSelect>

        <CSelect
            :value.sync="fileConfigurationComponent.delimiter"
            :options="[
                {
                    value: ',',
                    label: ',',
                },
                {
                    value: ';',
                    label: ';',
                },
            ]"
            :label="labelDelimiter"
            :horizontal="horizontal"
            :placeholder="placeholderDelimiter"
            :size="size"
        >
        </CSelect>
        <CSelect
            :value.sync="fileConfigurationComponent.enclosure"
            :options="defaultOptionsEnclosure"
            :label="labelEnclosure"
            :horizontal="horizontal"
            :placeholder="placeholderEnclosure"
            :size="size"
        >
        </CSelect>
        <CCSwitch
            :checked.sync="fileConfigurationComponent.compressed"
            :label="labelCompressed"
            :horizontal="{
                label: 'col-sm-2',
                input: 'col-sm-10',
            }"
            color="primary"
            name="action"
            shape="pill"
            variant="3d"
            :size="size"
        />
        <InputPassword
            :value.sync="fileConfigurationComponent.password"
            :placeholder="placeholderPassword"
            :label="labelPassword"
            :horizontal="defaultInputConfig.horizontal"
            :autocomplete="false"
            :size="size"
        />
        <InputList
            :value.sync="
                fileConfigurationComponent.headers
            "
            :placeholder="
                placeholderHeaders
            "
            :label="labelHeaders"
            :horizontal="
                defaultInputConfig.horizontal
            "
            :size="size"
        />
    </div>
</template>

<script>
import baseMixin from "~/mixins/base.js";
import CCSwitch from "~/components/CCSwitch.vue";
import InputPassword from "~/components/InputPassword.vue";
import InputList from "~/components/InputList.vue";

export default {
    name: "CCFileConfiguration",
    mixins: [baseMixin],
    components: {
        CCSwitch,
        InputPassword,
        InputList
    },
    data() {
        return {
            defaultOptionsEnclosure: [
                {
                    value: "\'",
                    label: "\'",
                },
                {
                    value: '\"',
                    label: '\"',
                },
            ],

            fileConfigurationComponent: {
                name: null,
                format: null,
                delimiter: null,
                enclosure: null,
                compressed: false,
                password: null,
                headers: [],
            },
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },

        labelName: {
            type: String,
            default: "Name",
        },

        placeholderName: {
            type: String,
            default: "Enter the name",
        },

        labelFormat: {
            type: String,
            default: "Format",
        },
        placeholderFormat: {
            type: String,
            default: "Select a format",
        },
        labelDelimiter: {
            type: String,
            default: "Delimiter",
        },
        placeholderDelimiter: {
            type: String,
            default: "Enter the delimiter",
        },
        labelEnclosure: {
            type: String,
            default: "Enclosure",
        },
        placeholderEnclosure: {
            type: String,
            default: "Enter the enclosure",
        },
        labelCompressed: {
            type: String,
            default: "Compressed",
        },
        labelPassword: {
            type: String,
            default: "Password",
        },
        placeholderPassword: {
            type: String,
            default: "Enter the password",
        },
        labelHeaders: {
            type: String,
            default: "Headers",
        },
        placeholderHeaders: {
            type: String,
            default: "Enter the headers",
        },

        value: {
            required: true,
        },
        horizontal: {
            type: Boolean|Object,
            default: false,
        },
        size: {
            type: String,
            default: "md",
        },
    },
    watch: {
        value: {
            async handler(newValue) {
                this.fileConfigurationComponent = newValue;
            },
            deep: true,
        },
        fileConfigurationComponent: {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
    },
    methods: {},
    async mounted() {
        if (this.value) {
            this.fileConfigurationComponent = this.value;
        }
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
